import DashboardEventBriefInfo, { EventInfo } from '@quickService/DashboardEventBriefInfo';
import DashboardEventInfo, { Body, Data } from '@quickService/DashboardEventInfo';
import PublicEventGetEventInfo from '@quickService/PublicEventGetEventInfo';
import { COS_STYLE_NAME } from '@utils/activity-type/add-option';
import useSWR from 'swr';

export type ActivityInfoData = Partial<Data> & Partial<EventInfo>;
export type BriefEventInfo = EventInfo;
/**
 * 管理员侧获取活动信息
 */
export function useActivityInfo(
  params: Body,
  isDisabled?: boolean,
): {
  activityInfo: ActivityInfoData | undefined;
  error: unknown;
  mutate: Function;
} {
  // prettier-ignore
  const { data, error, mutate } = useSWR({
    url: '/v2/activities/dashboard/event/info',
    id: params?.event_id,
  }, async ({ id }) => {
    if (isDisabled || !id) return undefined;
    const resp = await DashboardEventInfo({
      event_id: id,
      cover_image_type: params.cover_image_type || COS_STYLE_NAME.EVENT[1],
    });
    if (resp?.code !== 0) {
      const error: any = new Error(resp?.msg);
      error.status = resp?.code;
      throw error;
    }
    return resp.data;
  }, {
    revalidateOnFocus: false,
    focusThrottleInterval: 5 * 1000,
  });

  return {
    activityInfo: data,
    error,
    mutate,
  };
}

/** 已发布活动返回
 * publishInfo 当前对外信息，仅已发布活动才存在
 * activityInfo 当前最新活动信息
 *  */
export function useActivityBriefInfo(
  params: Body,
  isDisabled?: boolean,
): {
  activityInfo: Partial<EventInfo>;
  publishInfo?: EventInfo;
  error: unknown;
  mutate: Function;
} {
  const { data, error, mutate } = useSWR(
    {
      url: '/v2/activities/dashboard/event/brief-info',
      id: params?.event_id,
    },
    async ({ id }) => {
      if (isDisabled || !id) return {};
      const resp = await DashboardEventBriefInfo(params);
      if (resp?.code !== 0) {
        const error: Error & { status?: number } = new Error(resp?.msg);
        error.status = resp?.code;
        throw error;
      }
      return resp.data;
    },
    {
      revalidateOnFocus: false,
    },
  );
  return {
    activityInfo: data?.event_info,
    publishInfo: data?.published_event_info,
    error,
    mutate,
  };
}

/**
 * 用户侧获取活动信息
 */
export function useActivityInfoToC(params: Body): {
  activityInfo: ActivityInfoData;
  error: unknown;
  mutate: Function;
} {
  const { data, error, mutate } = useSWR(
    {
      url: '/v2/activities/public/event/get-event-info',
      id: params?.event_id,
    },
    async ({ id }) => {
      if (!id) return {};
      const resp = await PublicEventGetEventInfo({
        event_id: id,
      });
      if (resp?.code !== 0) {
        const error: Error & { status?: number } = new Error(resp?.msg);
        error.status = resp?.code;
        throw error;
      }
      return resp.data;
    },
    {
      revalidateOnFocus: false,
      focusThrottleInterval: 5 * 1000,
    },
  );

  return {
    activityInfo: data?.event_info,
    error,
    mutate,
  };
}
